
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import ColdDrinks from './colddrinks';
import Alcoholic from './alcoholic';
import BottleScreen from './bottle';
import Liquours from './liquours';
import Digestivos from './digestivos';
import HouseDrinks from './housedrinks';
import HotDrinks from './hotdrinks';
import DrinksCold from './drinkscold';
import {useTranslation} from 'react-i18next';

function Index({setShowHappy}) { 

    const { change, getInitData } = useRefresh();
    
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;


    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [housedrinks, sethousedrinks] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showColdDrinks, setShowColdDrinks] = useState(false);
    const [showAlcoholic, setShowAlcoholic] = useState(false);
    const [showBottle, setShowBottle] = useState(false);
    const [showHotDrinks, setshowHotDrinks] = useState(false);
    
    const [cocktail, setcoctail] = useState(false);
    const [liquuors, setliquors] = useState(false);
    const [beers, setbeers] = useState(false);
    const [digestivos, setdigestivos] = useState(false);
    const [showLiquors, setshowLiquors] = useState(false);
    const [showDigestivos, setshowDigestivos] = useState(false);
    const [showHouseDrinks, setshowHouseDrinks] = useState(false);
    



     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 1016) {
                sethousedrinks(item);
            }
                
            if (item.id === 1017) {
                setcoctail(item);
            }
            
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy} setShowColdDrinks={setShowColdDrinks}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{ width: '100%', marginBottom: 2, position: 'relative' }}>
                        
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 200,
                            height: 70,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 10,
                            
                            
                        }}
                        src={require('./assets/logo.png')}
                        />

                        <div onClick={() => {

                          setshowHotDrinks(true)
                            
                            
                         //  setshowHouseDrinks(true)
                            
                        }}>
                            <img
                                src={require(langEng ? './assets/hotdrinken.png': './assets/hotdrinks.png')}
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                    width: '100%',
                                    height: 300,
                                    marginTop: 30,
                                    marginBottom: 10,
                                    objectFit: 'contain',
                                    borderRadius: 25,
                                    pointerEvents: 'none',
                                }}
                            />
                        </div>

                        <div onClick={() => {
                         setShowColdDrinks(true)
                            
                      //     setshowHouseDrinks(true)
                            
                        }}>
                            <img
                                src={require(langEng ? './assets/coldrinksen.png': './assets/cooldrinks.png')}
                                onContextMenu={(e) => e.preventDefault()}
                                style={{
                                    width: '100%',
                                    height: 300,
                                    marginTop: 30,
                                    marginBottom: 10,
                                    objectFit: 'contain',
                                    borderRadius: 25,
                                    pointerEvents: 'none',
                                }}
                            />
                        </div>
                        
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showColdDrinks && <DrinksCold setShowHappy={setShowColdDrinks} />}
                {showAlcoholic && <Alcoholic setShowHappy={setShowAlcoholic} />}
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                {showLiquors && <Liquours setShowHappy={setshowLiquors} />}  
                {showDigestivos && <Digestivos setShowHappy={setshowDigestivos} />}  
                {showHotDrinks && <HotDrinks setShowHappy={setshowHotDrinks} />}  
                {showHouseDrinks && <HouseDrinks setShowHappy={setshowHouseDrinks} />}  
                {showHouseDrinks && <HouseDrinks setShowHappy={setshowHouseDrinks} />}  
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;